import { Icon } from '@/components/common';
import Icons from '@/const/icons';
import clsx from 'clsx';

/** A small purple radio-style circle indicator */
export const PurpleRadio: React.FC<{ selected: boolean }> = ({ selected }) => (
	<span
		className={clsx(
			'flex-shrink-0 inline-flex items-center justify-center rounded-full transition-all duration-150',
			'size-6 border border-primary',
			selected ? 'bg-primary' : 'bg-white'
		)}
	>
		{selected && (
			<Icon src={Icons.check} width={14} height={14} className="text-white" />
		)}
	</span>
);
